import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const createNotification = async (domain: string, flowId: number, newNotificationData: any): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `flows/${flowId}/message`,
        method: 'POST',
        params: newNotificationData,
        headers: {
            "Content-Type": "application/json",
        },
        domain,
    });
}